/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * GridBody CSS
 */
export const styles = css`
  :host {
    box-sizing: border-box;
    background-color: var(--nile-colors-white-base, var(--ng-colors-bg-primary));
  }
`;

export default [styles];
